var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-button',{attrs:{"type":"primary","icon":"plus"},on:{"click":function($event){$event.preventDefault();return _vm.$refs.modal.open($event)}}}),_c('modal',{ref:"modal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }